import React from 'react'
import PropTypes from 'prop-types'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import Button from './../Button/Button'
import ThemeConfig from './../../theme/ThemeConfig'
import { Menu, MenuItem } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

const verticalLine = {
  borderRight: '1px solid ' + ThemeConfig.palette.background.paper,
  height: '24px',
}

const paddingLeft12 = {
  paddingLeft: '12px',
}

const paddingLeft4 = {
  paddingLeft: '4px',
}

const paddingTop = { paddingTop: '20px' }

const BulkAction = props => {
  const {
    actionName,
    iconTag,
    toolTip,
    showVerticalDivider,
    disabled,
    selectTag,
    longActionsMenu,
    ...others
  } = props
  const [anchorEl, setAnchorEl] = React.useState(null)
  if (longActionsMenu) {
    const open = Boolean(anchorEl)
    const handleClose = () => {
      setAnchorEl(null)
    }
    const handleClick = event => {
      setAnchorEl(event.currentTarget)
    }
    const longActionsItems = []
    longActionsMenu.forEach(menuItem => {
      const handleActionClick = () => {
        handleClose()
        if (menuItem.onClick) {
          menuItem.onClick()
        }
      }
      longActionsItems.push(
        <MenuItem
          key={menuItem.id}
          value={menuItem.actionName}
          onClick={handleActionClick}
        >
          {menuItem.iconTag || ''} {menuItem.actionName || ''}
        </MenuItem>,
      )
    })
    return (
      <React.Fragment>
        {showVerticalDivider ? <div style={verticalLine} /> : ''}
        <div style={paddingLeft4} />
        <Button
          variant="text"
          color="tertiary"
          bulkActions={true}
          toolTip="More Actions"
          onClick={handleClick}
        >
          LONG ACTIONS
          <ArrowDropDownIcon />
        </Button>
        <Menu
          id="select-menu"
          keepMounted
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {longActionsItems}
        </Menu>
      </React.Fragment>
    )
  } else if (selectTag) {
    return (
      <React.Fragment>
        {showVerticalDivider ? <div style={verticalLine} /> : ''}
        {showVerticalDivider ? <div style={paddingLeft12} /> : ''}
        <div style={paddingTop}>{selectTag}</div>
        <Button
          variant="text"
          color="tertiary"
          bulkActions={true}
          toolTip={toolTip}
          disabled={disabled}
          {...others}
        >
          {iconTag || ''}
          {actionName || ''}
        </Button>
        <div style={paddingLeft4} />
      </React.Fragment>
    )
  } else {
    return (
      <React.Fragment>
        {showVerticalDivider ? <div style={verticalLine} /> : ''}
        {showVerticalDivider ? <div style={paddingLeft4} /> : ''}
        <Button
          variant="text"
          color="tertiary"
          bulkActions={true}
          toolTip={toolTip}
          disabled={disabled}
          {...others}
        >
          {iconTag || ''}
          {actionName || ''}
        </Button>
        {showVerticalDivider ? <div style={paddingLeft4} /> : ''}
      </React.Fragment>
    )
  }
}

ToggleSwitch.propTypes = {
  actionName: PropTypes.string,
  iconTag: PropTypes.string,
  toolTip: PropTypes.string,
  showVerticalDivider: PropTypes.bool,
  disabled: PropTypes.bool,
  selectTag: PropTypes.string,
  longActionsMenu: PropTypes.array,
  id: PropTypes.string.isRequired,
}

export default BulkAction
